import React from 'react';
import MainComponent from "../components/MainComponent";
import HeaderComponent from "../components/HeaderComponent";

function HomePageRoute () {
    return (
        <div className="home-page">

            <HeaderComponent />

            <MainComponent />
        </div>
    )
}

export default HomePageRoute;